import { BehaviorSubject } from 'rxjs';

export const openedModal$ = new BehaviorSubject({ type: '', params: {} });

export const getOpenedModal$ = () => openedModal$;

export const setOpenedModal$ = (openedModal: string, params: object = {}) =>
  openedModal$.next({ type: openedModal, params });
